export enum HomeWidgetType {
  timeTracker = 'timeTracker',
  entityWidget = 'entityWidget',
  overviewWidget = 'overviewWidget',
  relevantWidget = 'relevantWidget',
  calendarWidget = 'calendarWidget',
  widgetGroup = 'widgetGroup',
  divider = 'divider',
}
